<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>
                    Minutas de Visitantes
                    <v-spacer/>
                    <v-chip class="mr-2" color="primary" dark>{{ filteredMinutas.length }} registros</v-chip>
                    <v-dialog
                        ref="dialogDate"
                        v-model="modalDate"
                        :return-value.sync="filterDate"
                        persistent
                        width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="filterDate"
                                label="Filtrar por fecha"
                                prepend-icon="event"
                                readonly
                                clearable
                                v-on="on"
                                style="max-width: 200px"
                                class="mr-2"
                            />
                        </template>
                        <v-date-picker v-model="filterDate" scrollable locale="es-co">
                            <v-spacer/>
                            <v-btn text color="primary" @click="modalDate = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="$refs.dialogDate.save(filterDate)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        hide-details
                        style="max-width: 250px"
                    />
                </v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="filteredMinutas"
                    :search="search"
                    sort-desc
                    class="elevation-1"
                    :items-per-page="10"
                    no-data-text="No hay minutas registradas"
                    no-results-text="No se encontraron resultados"
                >
                    <template v-slot:item.fecha="{ item }">
                        {{ formatDate(item.fecha) }}
                    </template>
                    <template v-slot:item.vigilante="{ item }">
                        {{ item.vigilante ? (item.vigilante.first_name || '') + ' ' + (item.vigilante.last_name || '') : '' }}
                    </template>
                    <template v-slot:item.area="{ item }">
                        {{ item.area && item.area.name ? item.area.name : item.area || '' }}
                    </template>
                    <template v-slot:item.horaSalida="{ item }">
                        <v-chip v-if="item.horaSalida" color="green" dark x-small>{{ item.horaSalida }}</v-chip>
                        <v-chip v-else color="orange" dark x-small>En sitio</v-chip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn icon small @click="openDetail(item)">
                            <v-icon small>visibility</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card>

            <!-- Dialog detalle -->
            <v-dialog v-model="dialog" max-width="600">
                <v-card v-if="selected">
                    <v-card-title class="primary white--text">
                        <v-icon dark class="mr-2">assignment</v-icon>
                        Minuta - {{ selected.nombreVisitante }}
                    </v-card-title>
                    <v-card-text class="pt-4">
                        <v-row>
                            <v-col cols="6">
                                <div class="caption grey--text">Visitante</div>
                                <div class="body-1 font-weight-bold">{{ selected.nombreVisitante }}</div>
                            </v-col>
                            <v-col cols="6">
                                <div class="caption grey--text">Cedula</div>
                                <div class="body-1">{{ selected.cedula }}</div>
                            </v-col>
                            <v-col cols="4">
                                <div class="caption grey--text">Casa</div>
                                <div class="body-1">{{ selected.casa || '-' }}</div>
                            </v-col>
                            <v-col cols="4">
                                <div class="caption grey--text">Apto</div>
                                <div class="body-1">{{ selected.apto || '-' }}</div>
                            </v-col>
                            <v-col cols="4">
                                <div class="caption grey--text">Interior</div>
                                <div class="body-1">{{ selected.interior || '-' }}</div>
                            </v-col>
                            <v-col cols="6">
                                <div class="caption grey--text">Hora Entrada</div>
                                <div class="body-1">{{ selected.horaEntrada || '-' }}</div>
                            </v-col>
                            <v-col cols="6">
                                <div class="caption grey--text">Hora Salida</div>
                                <div class="body-1">{{ selected.horaSalida || 'Aun en sitio' }}</div>
                            </v-col>
                            <v-col cols="12">
                                <div class="caption grey--text">Autorizado por</div>
                                <div class="body-1">{{ selected.nombreAutorizante }}</div>
                            </v-col>
                            <v-col cols="12">
                                <div class="caption grey--text">Area</div>
                                <div class="body-1">{{ selected.area && selected.area.name ? selected.area.name : selected.area || '-' }}</div>
                            </v-col>
                            <v-col cols="12">
                                <div class="caption grey--text">Vigilante</div>
                                <div class="body-1">{{ selected.vigilante ? (selected.vigilante.first_name || '') + ' ' + (selected.vigilante.last_name || '') : '-' }}</div>
                            </v-col>
                            <v-col cols="12">
                                <div class="caption grey--text">Fecha</div>
                                <div class="body-1">{{ formatDate(selected.fecha) }}</div>
                            </v-col>
                            <v-col cols="12" v-if="selected.foto">
                                <div class="caption grey--text mb-1">Foto del visitante</div>
                                <v-img :src="selected.foto" max-height="300" contain class="grey lighten-3 rounded"/>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn text @click="dialog = false">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </v-content>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Minutas',
    data() {
        return {
            search: '',
            filterDate: null,
            modalDate: false,
            dialog: false,
            selected: null,
            headers: [
                { text: 'Fecha', value: 'fecha' },
                { text: 'Visitante', value: 'nombreVisitante' },
                { text: 'Cedula', value: 'cedula' },
                { text: 'Entrada', value: 'horaEntrada' },
                { text: 'Salida', value: 'horaSalida' },
                { text: 'Area', value: 'area' },
                { text: 'Vigilante', value: 'vigilante' },
                { text: 'Acciones', value: 'actions', sortable: false }
            ]
        }
    },
    computed: {
        ...mapState('minuta', ['minutas']),
        filteredMinutas() {
            if (!this.filterDate) return this.minutas
            return this.minutas.filter(m => {
                if (!m.fecha) return false
                const mDate = m.fecha.toDate ? m.fecha.toDate() : new Date(m.fecha)
                const filterStart = new Date(this.filterDate + 'T00:00:00')
                const filterEnd = new Date(this.filterDate + 'T23:59:59')
                return mDate >= filterStart && mDate <= filterEnd
            })
        }
    },
    methods: {
        openDetail(item) {
            this.selected = item
            this.dialog = true
        },
        formatDate(fecha) {
            if (!fecha) return '-'
            const d = fecha.toDate ? fecha.toDate() : new Date(fecha)
            return d.toLocaleDateString('es-CO', { year: 'numeric', month: '2-digit', day: '2-digit' })
        }
    }
}
</script>
